const market = {
	dsbz: '待上币种',
	kpsj:'开盘倒计时/开盘时间',
	ykp: '已开盘',
	kpdjs: '开盘倒计时',
	worning: '非最終交易单价，仅供参考',
	swapTab_1: 'USDT本位合约',
	swapTab_2: '币本位合约',
	searchCoin: '搜索想要的币种',
	risk: '风险提示',
	addSelfCode: '添加自选',
	pair: '币对',
	latestPrice: '最新价',
	changeHour: '涨跌幅',
	highHour: '24H最高',
	lowHour: '24H最低',
	priceTrend: '价格趋势（3日）',
	volumeHour: '24H成交量',
	noSearch: '暂无搜索币种',
	noAdd: '暂未添加自选',
	noYet: '暂未上架该币种',
	noBi: '暂未上线币种',
	wan: '万',
	qian: '千',
	yi: '亿',
	yxhy: '永续合约',
	wghy: '网格合约',
	cxjy:
		'创新区币种多在技术与市场等方面拥有一定成果，但其价格波动较大，风险也相对较高。建议您仔细查阅相关资料，在自身可承受范围内决定是否参与。',
	qljy:
		'潜力交易区尚处于市场发展初期，BiKing无法对其价值共识与市场流通情况做出任何保证。请您仔细浏览项目信息，在自身能够承受的范围内审慎参与投资。',
	qljyDao: 'DAO交易区尚处于市场发展初期，BiKing无法对其价值共识与市场流通情况作出任何保证。请您仔细浏览项目信息，在自身能够承受的范围内审慎参与投资。',
	default: '交易区尚处于市场发展初期，BiKing无法对其价值共识与市场流通情况作出任何保证。请您仔细浏览项目信息，在自身能够承受的范围内审慎参与投资。',
  storage: '存储交易区尚处于市场发展初期，BiKing无法对其价值共识与市场流通情况作出任何保证。请您仔细浏览项目信息，在自身能够承受的范围内审慎参与投资',
	dlt:
		'低流通区数字资产市场流通性较低，存在着下架退市的风险。参与投资前建议谨慎考虑。',
	defi:
		'DEFI交易区尚处于市场发展初期，BiKing无法对其价值共识与市场流通情况作出任何保证。请您仔细浏览项目信息，在自身能够承受的范围内审慎参与投资。',
	nft: "NFT交易区尚处于市场发展初期，BiKing无法对其价值共识与市场流通情况作出任何保证。请您仔细浏览项目信息，在自身能够承受的范围内审慎参与投资。",
	
	hz: "永续",
	yx: "研选",
	yjyzx: "研究院甄选项目",
	zx: '自选',
	bb: '现货',
	hy: '合约',
	zfb: '涨幅榜',
	xbb: '新币榜',
	bd: '币对',
	zxj: '最新价',
	zdf24: '24H涨跌幅',
	high24: '24H最高',
	low24: '24H最低',
	turnover24: '24H成交量',
	zd24: '24h涨跌',
	zjrzd: '价格/日涨跌',
	scgl: '市场概览',
	jysj: '交易数据',
	fyje: "返佣金额",
	ms: "是",
    mf: "否",
	是否交易:'是否交易',
	推荐好友:'推荐好友',
	推荐: "推荐",
	合约交易返佣:'获得高额合约交易返佣',
	我的返佣比例:'我的返佣比例',
	好友返佣比例:'好友返佣比例',
	推荐码:'推荐码',
	交易人数:'交易人数',
	推荐总览:'推荐总览',
	推荐人数:'推荐人数',
	推荐链接:'推荐链接',
	一键分享:'一键分享',
	合约返佣:'合约累计返佣',
	推荐记录:'推荐记录',
	返佣记录:'返佣记录',
	推荐好友:'推荐好友',
	请输入账户UID:'请输入账户UID',
	账户UID:'账户UID',
	注册时间:'注册时间（UTC+8）',
	合约手续费:'合约手续费',
	返佣活动规则说明:'返佣活动规则说明：',
	使用你的推荐链接:'使用您的推荐链接或推荐码注册的用户才算您的被邀请人，如用户注册时未填写推荐码，则邀请关系不成立；',
	被邀请人产生的真实交易手续费:'被邀请人产生的真实交易手续费，邀请人可获得交易手续费对应比例的返佣，次日返至邀请人账户，具体入账时间会在每日4点之后；',
	用户邀请朋友无上限:'用户邀请朋友无上限,被邀请人只有进行合约交易的手续费会计入返佣；',
	被邀请人只有进行合约:'被邀请人只有进行合约交易的手续费会计入返佣；',
	不允许任何用户通过多:'不允许任何用户通过多个账号进行自我邀请行为，一经查实，所有的返佣将会被取消，被邀请账号的手续费返佣也会被取消',
	由于市场环境的改变:'由于市场环境的改变，欺诈风险的存在等原因，Biking保留随时对返佣规则作出调整的最终解释权。',
	保留对活动的最终解释权:'如有任何疑问，请联系人工客服。'
};

export { market };



// WEBPACK FOOTER //
// ./src/i18n/lang/market/zh.js